import tariff from '@/api/tariff';

const state = {
    tariffList: '',
};

const getters = {
    balance: (state) => state.tariffList,
};

const actions = {
    getTariffList: (context) => {
        tariff
            .fetchTariffList()
            .then((res) => {
                context.commit('TARIFF', res.body.results);
            })
            .catch((error) => {
                console.log(error);
            });
    },
};

const mutations = {
    TARIFF: (state, payload) => {
        state.tariffList = payload;
        console.log('tariff page data:', state.tariffList);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
